export default {
  EBWT_WIN: 'win',
  EBWT_BIG_WIN: 'big_win',
  EBWT_MEGA_WIN: 'mega_win',
  EBWT_EPIC_WIN: 'epic_win',
}
